import { render } from "./Dimensions.vue?vue&type=template&id=00f83a7a&scoped=true"
import script from "./Dimensions.vue?vue&type=script&lang=js"
export * from "./Dimensions.vue?vue&type=script&lang=js"

import "./Dimensions.vue?vue&type=style&index=0&id=00f83a7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f83a7a"]])

export default __exports__